var productZoomSlider = null;
const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]'),
    zoomBtns: document.querySelectorAll('[data-productZoom]'),


    cartCheckout: document.querySelector('.product-form'),
    checkoutSticky: document.querySelector('.pdp-qty-btns')
};

const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
window.productMedia = mediaJSON;
class TemplateProductJS {
    constructor() {
        // Custom code for product page goes here
        this.stickyCheckout();

        selectors.zoomBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                let currentTarget = event.target;
                this.manageZoom(currentTarget);
            })
        });

    }

    // Sticky checkout container on oage scroll
    stickyCheckout() {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const checkoutStickyBoxRect = selectors.checkoutSticky?.getBoundingClientRect();
                
                if (entry.isIntersecting || checkoutStickyBoxRect.top > 0) {
                    selectors.checkoutSticky.classList.remove('active');
                } else {
                    selectors.checkoutSticky.classList.add('active');
                }
            });
        });
        observer.observe(selectors.cartCheckout);
    }

    manageZoom(currentTarget) {
        let currentSlide = currentTarget.closest('.product--media');
        let currentSlideIndex = 1;
        if (currentSlide) currentSlideIndex = Array.from(currentSlide.parentNode.children).indexOf(currentSlide);

        let zoomSlider = '';
        window.productMedia.forEach(i => {
            if (i.media_type == "external_video") {
                zoomSlider += `<div class="swiper-slide bg-white carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                  <div class="custom-video-container">
                      <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                          <div class="cta-btn" data-aos="hero">
                              <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                  <span class="icon-play text-body"></span>
                              </button>
                              <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                  <span class="icon-pause"></span>
                              </button>
                          </div>
                          <div class="content-section">
                              <div class="poster-image">
                                  <img class="img-fluid"
                                  src="${i.preview_image.src}"
                                  alt="${i.alt}"
                                  />
                              </div>
                          </div>
                          <div class="video-section" tabindex="0"></div>
                      </custom-video>
                  </div>
              </div>`;
            } else if (i.media_type == "video") {
                zoomSlider += `<div class="swiper-slide bg-white carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                  <div class="custom-video-container">
                      <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                          <div class="cta-btn">
                              <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                  <span class="icon-play text-body"></span>
                              </button>
                              <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                  <span class="icon-pause"></span>
                              </button>
                          </div>
                          <div class="content-section">
                              <div class="poster-image">
                                  <img class="img-fluid"
                                  src="${i.preview_image.src}"
                                  alt="${i.alt}"/>
                              </div>
                          </div>
                          <div class="video-section" tabindex="0"></div>
                      </custom-video>
                  </div>
              </div>`;
            } else if (i.media_type == "image") {
                zoomSlider += `<div class="swiper-slide bg-white carousel-cell d-flex align-items-center justify-content-center zoom--product-image" data-mediaID="${i.id}" role="treeitem">
                  <img class="h-100 img-fluid object-fit-contain w-100"
                  src="${i.preview_image.src}"
                  alt="${i.alt}"
                  width="${i.preview_image.width}"
                  height="${i.preview_image.height}"
                  loading="lazy"
                  />
              </div>`;
            }
        });
        let finalHTML = `<slider-element class="swiper-container zoom-slider position-relative carousel w-100">
          <div class="swiper swiper-slider zoom--product-images"
              data-slider='{
                      "loop": false,
                      "effect": "fade",
                      "observer": true,
                      "observeParents": true,
                      "slidesPerView": "1",
                      "spaceBetween": 15,
                      "grabCursor": true,
                      "navigation": {
                          "nextEl": ".zoom-next",
                          "prevEl": ".zoom-prev"
                      }
                  }' role="tree">
              <div class="swiper-wrapper" >${zoomSlider}</div>
          </div>
          <div class="swiper-button-prev zoom-prev start-0 icon-prev ms-sm-4 ms-2"></div>
          <div class="swiper-button-next zoom-next end-0 icon-next me-sm-4 me-2"></div>
          <zoom-feature>
          <div class="bottom-0 d-flex end-0 flex-column position-fixed z-index-1 zoom-controls mb-sm-4 mb-2 me-2 me-sm-4" style="gap:5px;">
                <button class="zoom-plus zoom_btn icon-plus p-1 text-body my-auto transition modal__close-button bg-primary-100 d-flex align-items-center justify-content-center rounded-circle"></button>
                <button class="zoom-minus zoom_btn icon-minus p-1 text-body my-auto transition modal__close-button bg-primary-100 d-flex align-items-center justify-content-center rounded-circle disabled"></button>
          </div>
          </zoom-feature>
      </slider-element>`;

        const zoomContainer = document.getElementById('PopupModal-zoom');
        if (zoomContainer) {
            zoomContainer.querySelector('.modal-body').innerHTML = finalHTML;
            zoomContainer.show();
            if (productZoomSlider) productZoomSlider.slideTo(currentSlideIndex, 2000, true);
        }
    }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();



class ZoomFeature extends HTMLElement {
    constructor() {
        super();
        this.zoomRatio = 1; // Default zoom ratio
        this.maxZoomRatio = 4; // Maximum allowed zoom ratio
        this.isDragging = false; // Track dragging state
        this.isPinching = false; // Track pinch state
        this.startX = 0; // Starting X position for touch
        this.startY = 0; // Starting Y position for touch
        this.translateX = 0; // Current X translation
        this.translateY = 0; // Current Y translation
        this.initialPinchDistance = 0; // Initial pinch distance
        this.lastPinchZoom = 1; // Last pinch zoom ratio
        this.activeImage = null; // Reference to the currently zoomed image
        this.setupZoomControls();
    }

    setupZoomControls() {
        const zoomPlusBtns = this.querySelectorAll('.zoom-plus');
        const zoomMinusBtns = this.querySelectorAll('.zoom-minus');

        zoomPlusBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                
                if (this.zoomRatio < this.maxZoomRatio) {
                    this.zoomRatio += 1;
                    if (this.zoomRatio >= this.maxZoomRatio) this.disableButton(btn);
                }
                this.updateZoom()
            });
        });
        
        zoomMinusBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                if (this.zoomRatio > 1) {
                    this.zoomRatio -= 1;
                    if (this.zoomRatio < this.maxZoomRatio) this.enableButton(document.querySelector('.zoom-plus'));
                }
                this.updateZoom();
                
            });
        });
        setTimeout(() => {
            this.enableZoomOnTouch();
        }, 1000);
    }

    enableZoomOnTouch() {
        const images = document.querySelectorAll('#PopupModal-zoom .swiper-slide img');
        images.forEach((image) => {
            // Touch events for mobile
            image.addEventListener('touchstart', (event) => this.onTouchStart(event));
            image.addEventListener('touchmove', (event) => this.onTouchMove(event));
            image.addEventListener('touchend', (event) => this.onTouchEnd(event));
        });
    }
    

    onTouchStart(event) {
        event.stopImmediatePropagation();
        if (event.touches.length === 2) {
            // Start pinch gesture
            this.isPinching = true;
            this.initialPinchDistance = this.calculatePinchDistance(event.touches);
            this.lastPinchZoom = this.zoomRatio;
        } else if (event.touches.length === 1 && this.zoomRatio > 1) {
            // Start drag gesture
            this.isDragging = true;
            this.startX = event.touches[0].clientX - this.translateX;
            this.startY = event.touches[0].clientY - this.translateY;
        }
        if (this.zoomRatio > 1) {
            const sliderElement = document.querySelector('.zoom-slider');
            if (sliderElement && typeof sliderElement.allowTouchMove === 'function') {
                sliderElement.allowTouchMove(false);
            }
        }

        // document.body?.classList.add('overflow-hidden', 'touch-action-none');
    }

    onTouchMove(event) {
        event.stopImmediatePropagation();
        if (this.isPinching && event.touches.length === 2) {
            const currentPinchDistance = this.calculatePinchDistance(event.touches);
            const pinchZoomFactor = currentPinchDistance / this.initialPinchDistance;
            this.zoomRatio = Math.min(
                Math.max(this.lastPinchZoom * pinchZoomFactor, 1),
                this.maxZoomRatio
            );
            this.updateZoom();
        } else if (this.isDragging && event.touches.length === 1) {
            const touch = event.touches[0];
            this.translateX = touch.clientX - this.startX;
            this.translateY = touch.clientY - this.startY;

            const maxTranslateX = ((this.zoomRatio - 1) * this.activeImage.offsetWidth) / 2;
            const maxTranslateY = ((this.zoomRatio - 1) * this.activeImage.offsetHeight) / 2;

            this.translateX = Math.max(Math.min(this.translateX, maxTranslateX), -maxTranslateX);
            this.translateY = Math.max(Math.min(this.translateY, maxTranslateY), -maxTranslateY);

            this.activeImage.style.transform = `scale(${this.zoomRatio}) translate3d(${this.translateX}px, ${this.translateY}px, 0px)`;
            this.activeImage.style.transition = 'none';
        }
        if (this.zoomRatio > 1) {
            const sliderElement = document.querySelector('.zoom-slider');
            if (sliderElement && typeof sliderElement.allowTouchMove === 'function') {
                sliderElement.allowTouchMove(false);
            }
        }
    }

    onTouchEnd(event) {
        event.stopImmediatePropagation();
        if (event.touches.length < 2) {
            this.isPinching = false;
        }
        if (event.touches.length === 0) {
            this.isDragging = false;
        }
        if (this.zoomRatio < 2) {
            document.querySelector('zoom-feature')?.resetTransform();
            const sliderElement = document.querySelector('.zoom-slider');
            if (sliderElement && typeof sliderElement.allowTouchMove === 'function') {
                sliderElement.allowTouchMove(true);
            }
        }
    }

    calculatePinchDistance(touches) {
        const [touch1, touch2] = touches;
        const dx = touch2.clientX - touch1.clientX;
        const dy = touch2.clientY - touch1.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    updateZoom() {
        const activeImage = document.querySelector('#PopupModal-zoom .swiper-slide-active img');
        if (activeImage) {
            this.activeImage = activeImage;
            this.activeImage.style.transform = `scale(${this.zoomRatio}) translate3d(${this.translateX}px, ${this.translateY}px, 0px)`;
            this.activeImage.style.transformOrigin = 'center center';
            this.activeImage.style.transition = 'transform 0.3s ease';

            // Update zoom buttons based on current zoom ratio
            const zoomPlusBtn = document.querySelector('.zoom-plus');
            const zoomMinusBtn = document.querySelector('.zoom-minus');

            if (this.zoomRatio >= this.maxZoomRatio) {
                this.disableButton(zoomPlusBtn);
            } else {
                this.enableButton(zoomPlusBtn);
            }

            if (this.zoomRatio <= 1) {
                this.disableButton(zoomMinusBtn);
            } else {
                this.enableButton(zoomMinusBtn);
            }
        }
    }

    resetTransform() {
        this.activeImage = this.activeImage || document.querySelector('#PopupModal-zoom .swiper-slide-active img');
        if (this.activeImage) {
            this.translateX = 0;
            this.translateY = 0;
            this.zoomRatio = 1;
            this.activeImage.style.transform = `scale(1) translate3d(0px, 0px, 0px)`;

            const zoomPlusBtn = this.querySelector('.zoom-plus');
            const zoomMinusBtn = this.querySelector('.zoom-minus');
            this.enableButton(zoomPlusBtn);
            this.disableButton(zoomMinusBtn);
        }
    }

    disableButton(button) {
        if (button) {
            button.disabled = true;
            button.classList.add('disabled');
        }
    }

    enableButton(button) {
        if (button) {
            button.disabled = false;
            button.classList.remove('disabled');
        }
    }
}

customElements.define('zoom-feature', ZoomFeature);